module.exports = __webpack_public_path__ + "assets-cabinet/img/plus-icon.9817ccec.svg";